import { setDefaultOptions } from 'date-fns'
import type { Locale } from 'date-fns'
import { enUS, hi, id, ja, ko, ms, ta, th, vi, zhCN, zhHK, zhTW } from 'date-fns/locale'

/**
 * date-fns locale for an i18n language code. date-fns ships no en-SG —
 * month/day names match en-US (patterns here are explicit, so en-GB's
 * day-first ordering never applies). Unknown codes fall back through
 * the bare language subtag to en-US.
 */
export function dateFnsLocale(language: string): Locale {
  switch (language) {
    case 'ms':
      return ms
    case 'id':
      return id
    case 'zh-CN':
      return zhCN
    case 'zh-HK':
      return zhHK
    case 'zh-TW':
      return zhTW
    case 'hi':
      return hi
    case 'ta':
      return ta
    case 'th':
      return th
    case 'vi':
      return vi
    case 'ko':
      return ko
    case 'ja':
      return ja
    case 'en':
    case 'en-SG':
    default:
      return enUS
  }
}

/**
 * Point date-fns' global default locale at the UI language. Every
 * `format()` / `formatDistanceToNow()` call without an explicit locale —
 * including `formatTime` via date-fns-tz, which delegates to `format` —
 * then renders month/day names in the UI language instead of English.
 * Called once at i18n boot and on every `languageChanged`.
 */
export function syncDateFnsLocale(language: string): void {
  setDefaultOptions({ locale: dateFnsLocale(language) })
}
